import baseAPI from '@/http'

const router = 'api/MunicipiosEixos'

export const municipioEixoApi = {
  create: (city) => baseAPI.post(`${router}/cadastrar-municipio-eixo`, city),
  update: (city) => baseAPI.put(router, city),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/${id}`),
  listNames: () => baseAPI.get(router + '/get-nomes'),
  getTasksReport: (id) => baseAPI.get(`${router}/relatorio-tarefa/${id}`)
}
